import React from 'react';

//Returns the biger image selected from list of small images
//in the list in desktop view
const ImageDetail = ({ image }) => {
    return (
        <div className='image-detail'>
            <img
                src={image}
                className='detail-image'
                alt=''
            />
        </div>
    )
}

export default ImageDetail;


// WEBPACK FOOTER //
// ./src/components/image-detail.js